import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "selfAnalysis"
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("自主分析")]), _c('div', {
    staticClass: "sa_toolbar"
  }, [_c('label', {
    staticClass: "sa_label"
  }, [_vm._v("案場")]), _c('b-form-select', {
    staticClass: "sa_site",
    attrs: {
      "options": _vm.siteOptions,
      "disabled": !_vm.siteOptions.length,
      "size": "sm"
    },
    model: {
      value: _vm.siteCode,
      callback: function callback($$v) {
        _vm.siteCode = $$v;
      },
      expression: "siteCode"
    }
  }), _vm.withData.length ? _c('span', {
    staticClass: "sa_stamp"
  }, [_vm._v(" 已建主檔：" + _vm._s(_vm.withData.map(function (s) {
    return s.code;
  }).join('、')) + " ")]) : _vm.siteOptions.length ? _c('span', {
    staticClass: "sa_stamp"
  }, [_vm._v("目前還沒有任何案場建過主檔")]) : _vm._e()], 1), _vm.error ? _c('b-alert', {
    staticClass: "mx-2 py-2",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle mr-1"
  }), _vm._v(_vm._s(_vm.error) + " ")]) : _vm._e(), !_vm.schema && !_vm.error ? _c('b-spinner', {
    staticClass: "mx-3 my-4",
    attrs: {
      "variant": "secondary"
    }
  }) : _vm._e(), _vm.schema ? _c('b-tabs', {
    staticClass: "mx-2",
    attrs: {
      "nav-class": "sa_segment",
      "lazy": ""
    },
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-sitemap"
        }), _vm._v("拓撲階層")];
      },
      proxy: true
    }], null, false, 2340396897)
  }, [_c('TopologyNodesPanel', {
    attrs: {
      "def": _vm.schema.inverter_topology_nodes,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-bolt"
        }), _vm._v("節點標準電壓")];
      },
      proxy: true
    }], null, false, 543784497)
  }, [_c('VoltageConfigsPanel', {
    attrs: {
      "def": _vm.schema.node_voltage_configs,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-server"
        }), _vm._v("INV主檔")];
      },
      proxy: true
    }], null, false, 1991822822)
  }, [_c('InverterMasterPanel', {
    attrs: {
      "def": _vm.schema.inverter_master,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-project-diagram"
        }), _vm._v("MPPT串列對應")];
      },
      proxy: true
    }], null, false, 4212372680)
  }, [_c('MpptStringMapPanel', {
    attrs: {
      "def": _vm.schema.mppt_string_map,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-solar-panel"
        }), _vm._v("串列設計")];
      },
      proxy: true
    }], null, false, 1698391141)
  }, [_c('StringDesignPanel', {
    attrs: {
      "def": _vm.schema.string_design,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-list-ol"
        }), _vm._v("INV狀態碼對照")];
      },
      proxy: true
    }], null, false, 168824541)
  }, [_c('StatusCodesPanel', {
    attrs: {
      "def": _vm.schema.site_inverter_status_codes,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };